export const CMB = {
    SAVE_MODE: 'CMB_SAVE_MODE',
    SAVE_PHONE: 'CMB_SAVE_PHONE',
    SAVE_DATE: 'CMB_SAVE_DATE',
    SAVE_CONSENT: 'CMB_SAVE_CONSENT',
    SAVE_VALIDATION_STATE: 'CMB_SAVE_VALIDATION_STATE',
    SAVE_SUBMITTED_STATE: 'CMB_SAVE_SUBMITTED',
    SAVE_COUNTDOWN_REMAINING: 'CMB_SAVE_COUNTDOWN_REMAINING',
    RESET: 'CMB_RESET'
};

export const CMB_MODE = {
    IMMEDIATE: 'IMMEDIATE',
    DELAYED: 'DELAYED',
    SCHEDUELE: 'SCHEDUELE'
};
